import { render, staticRenderFns } from "./FourColumnBanner.vue?vue&type=template&id=3a48701c&scoped=true&"
import script from "./FourColumnBanner.vue?vue&type=script&lang=js&"
export * from "./FourColumnBanner.vue?vue&type=script&lang=js&"
import style0 from "./FourColumnBanner.vue?vue&type=style&index=0&id=3a48701c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48701c",
  null
  
)

export default component.exports